import React from "react";
import { Flex, Box, Stack, Text, Spacer, Button } from "@chakra-ui/react";
import { Link } from "react-scroll";
import {
  FaSun,
  FaMoon,
  FaTimes,
  FaEllipsisH,
  FaPaperPlane,
  FaDownload,
  FaHSquare,
  FaHackerNews,
  FaHamsa,
  FaCode,
} from "react-icons/fa";
const MenuItem = ({ children, isLast, to = "/", ...rest }) => {
  return (
    <Text display="block" {...rest} colorScheme={"teal"}>
      {children}
    </Text>
  );
};

function Newnav(props) {
  return (
    <Box bg={'inherit'} position={'sticky'} zIndex={1} top={0} pt={'30px'} pl={'100px'} pb={'30px'} pr={'100px'} height={'10vh'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
        <Box fontSize={'50px'} color={'rgb(43,188,212)'}>
            &#123; &#125;
        </Box>
        <Box>
<Stack
        spacing={8}
        align="center"
        justify={["center", "space-between", "flex-end", "flex-end"]}
        direction={["column", "column", "row", "row"]}
        pt={[4, 4, 0, 0]}
      >
        <MenuItem>
          {" "}
          <Button variant={"ghost"}>
            <Link to="about" smooth={true}>
              {" "}
              About Me
            </Link>
          </Button>
        </MenuItem>
        <MenuItem>
          <Button variant={"ghost"}>
            <Link to="projects" smooth={true}>
              {" "}
              Projects
            </Link>
          </Button>
        </MenuItem>
        <MenuItem>
        <a href="hamza_resume_r.pdf" download>
          <Button variant={'ghost'} >
          <Box mr={2}>
              {" "}
              <FaDownload />{" "}
            </Box>
            Download CV
        </Button>
        </a>
        
        </MenuItem>
        <MenuItem>
        <a href="mailto:alsorkhyy@gmail.com?subject=Lets%20talk"><Button bgGradient={"linear(to-r,teal.400, cyan.400)"}>
            <Box mr={2}>
              {" "}
              <FaPaperPlane />{" "}
            </Box>
            Lets Talk
          </Button></a>
          
        </MenuItem>
        
      </Stack>

        </Box>
        <Button
        variant={'link'}
          leftIcon={props.dark ? <FaSun  size={'40px'} /> : <FaMoon  size={'40px'} />}
          onClick={props.change}
        ></Button>
    </Box>
  )
}

export default Newnav